<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <AddressForm
          v-model="address"
          title="Editace adresy"
          :edit="true"
          :loading="loading"
          :saving="saving"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import AddressForm from '@/components/forms/AddressForm'

export default {
  name: 'AddressEdit',
  components: {
    AddressForm,
  },
  data() {
    return {
      address: {},
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadAddress()
  },
  methods: {
    ...mapActions({
      getAddress: 'address/getAddress',
      updateAddress: 'address/updateAddress',
    }),
    loadAddress() {
      this.loading = true
      this.getAddress(this.$route.params.id)
        .then((response) => {
          this.address = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.saving = true
      this.updateAddress(this.address)
        .then(() => {
          this.$router.back()
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
